/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'magnify': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<defs/><path pid="0" id="magnify" class="cls-1" d="M116 36.862l-4.379-4.379a6.509 6.509 0 1 0-1.148 1.148l4.379 4.379zm-9.507-3.486a4.873 4.873 0 1 1 3.445-1.427 4.843 4.843 0 0 1-3.446 1.427z" transform="translate(-100 -22)"/>'
  }
})
